import { Container, Grid, Paper } from '@mui/material';
import { Box } from '@mui/system';
import { RichTextInput } from 'ra-input-rich-text';
import * as React from 'react';
import {
  Edit,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  required,
  ImageInput,
  BooleanInput,
  NumberInput,
  DateInput,
  DateTimeInput,
  ImageField,
  useGetOne,
  Loading,
} from 'react-admin';
import { useParams } from 'react-router';
import { OrderModel } from '../../config/types/models';
import OrderFunctions from './editPage/OrderFunctions';
import OrderInfoSection from './editPage/OrderInfoSection';
import OrderItems from './editPage/OrderItems';
import UserInfoSection from './editPage/UserInfoSection';

export default function ResourceEdit() {
  const { id } = useParams();

  const { data, isLoading } = useGetOne('order', {
    id: parseInt(id?.toString() || ''),
  }) as {
    data: OrderModel;
    isLoading: boolean;
  };
  if (isLoading) {
    return <Loading />;
  }
  return (
    <Container>
      <Paper sx={{ padding: 2, marginTop: 2 }}>
        <OrderFunctions order={data} />
        <Grid container sx={{ padding: 2 }}>
          <Grid lg={6} md={6} sm={12}>
            <UserInfoSection user={data.user} />
          </Grid>
          <Grid lg={6} md={6} sm={12}>
            <OrderInfoSection order={data} />
          </Grid>
        </Grid>
        <Grid container>
          <Grid lg={12} md={12} sm={12}>
            <OrderItems
              orderItems={data.orderItems}
              totalProductPrice={data.productsTotalPrice}
              shippingPrice={data.shippingPrice}
              discount={data.discount}
              membershipDiscount={data.membershipDiscount}
              total={data.total}
            />
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
}

const styles = {
  boxStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  editStyle: {
    width: '50%',
    minWidth: 200,
  },
  inputStyle: {
    width: '100%',
  },
};
